import React, { useEffect } from "react";
import "./index.scss";
import {  useSelector } from "react-redux";

const TotalCount = ({ className = '',name, records}) => {


	return (
		<>
		   
			{records ? <div className={`total-count-blc ${className}`}>
				<span>{name}<span>:</span> </span> <input type="hidden" id="veryUniqueId"/> {records}
			</div> : null}
		</>
	);
}

export default TotalCount;